import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('grupos');

export const check = () => useBasicAuth.checkToken();

export const findGrupoById = (id) => 
  axios.get(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGrupo = () => 
  axios.get(urlAPI + "/findAll" , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGrupoByDeleted = (value) => 
  axios.get(urlAPI + "/deleted/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  }); 

export const findAllGrupoByEnabled = (value) => 
  axios.get(urlAPI + "/enabled/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  }); 

export const addGrupo = (obj) => 
  axios.post(urlAPI + "/addGrupo", JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const updateGrupo = (obj) => 
  axios.put(urlAPI + "/updateGrupo/" + obj.grupo.id, JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const deleteGrupo = (id) => 
  axios.delete(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });